import type { FaireProductEntity } from "../../entity_types/product";

export const p_phq9tx8p59: FaireProductEntity = {
  token: "p_phq9tx8p59",
  type: "product",
  name: "Opal Stargazer Necklace",
  brandToken: "b_2ki6r755",
  brandName: "JOY DRAVECKY JEWELRY",
  imageUrl:
    "https://cdn.faire.com/fastly/b0fea962ca559cee123acb484db5b7705aa6832271821f3a2f59439c1335155b.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/079f776f60a18a0e2f560a2db17493a66147c66a6b03db241051fcca217b3627.jpeg",
    "https://cdn.faire.com/fastly/d2630e622bb435fa60f4547a00e7e62b4f6e76ee6505edfa83c7bb6a98ffa5e6.jpeg",
  ],
  priceDollars: 56,
  description:
    "This one's for the goddesses. The Stargazer Necklace features a shimmering gold sunburst pendant with a fiery opal center surrounded by sparkling CZs. This piece was made to reflect the sunlight on summer days, and to remind you of those days when the weather won't cooperate.\n\nChain\n\n * Measurement: 18 Inch + 2 Inch Extender \n * Materials: 14k Gold Plated Over Brass \nCharm\n\n * Measurement: 20mm \n * Materials: 14k Gold Plated Over Brass / Opal Stone / AAA Rated Cubic Zirconia \nOverall\n\n * Care & Cleaning (recommended): Avoid All Water Types, Store In Dry Places, & Clean With Gold Jewelry Cleaner \nLifetime Warranty / 30-Day Return Policy \nProcessing Time for This Product Is 1-2 Business Days Prior to Shipment.\n\n",
  tags: [],
  msrpDollars: 140,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-19T21:22:48.364Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
